<template>
    <div id="display">
        <div class="sidenav">
            <a id="selected">Reading</a>
            <a>Fix It</a>
            <a>Interior Design</a>
            <a>Landscaping</a>
        </div>
        <div id="listing">
            <router-link
                tag="div"
                :to="{
                    path: `/blog/${book.title}`,
                    query: {
                        post: index,
                        category: 'books'
                    }
                }"
                v-for="(book, index) in books"
                :key="index"
                @click.native.stop
            >
                <img class="icon" :src="getSource(book)" :alt="book.name + ' Image'" >
            </router-link>
        </div>
        <!-- https://dev.to/charleswritescode/how-to-display-a-route-as-a-modal-in-vue-js-iid -->
        <!-- https://codepen.io/williamliaw/pen/gPMdrm Modal Animation-->
        <div id="modal" class="modal modal-effect" :class="{show:showModal}">
            <div id="content" class="content" v-click-outside="back">
                <span class="close" @click="$router.go(-1)">&times;</span>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import Posts from '@/assets/data/posts.js'

export default {
    components: {
    },
    data() {
        return {
            books: Posts.books,
            showModal: false,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler: function(newVal) {
                this.showModal = newVal.meta && newVal.meta.showModal;
            }
        },
    },
    methods: {
        getSource: function (book) {
            return require('@/assets/blog/books/covers/' + book.cover);
        },
        back: function() {
            if (this.showModal) {
                this.$router.go(-1);
            }
        }
    }
}
</script>

<style>
    .modal { /*md-modal*/ 
        visibility: hidden;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        backface-visibility: hidden;
    }
    .show {
        visibility: visible;
    }
    .modal-effect { /*md-effect-1*/ }
    .content { /*md-content*/ }
    .modal-effect .content {
        -webkit-transform: scale(0.7);
        -ms-transform: scale(0.7);
        transform: scale(0.7);
        opacity: 0;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
    }
    .show.modal-effect .content {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
    #modal { /*modal-1*/
        display: block;
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgb(0,0,0);
        background-color: rgba(0,0,0,0.75); 
        margin: 0px;
    }
    #content {
        position: relative;
        display: flex;
        justify-content: center;
        background-color: #414141;
        margin: auto;
        padding: 20px;
        width: 80vw;
        height: 100vh;
        overflow-y: auto;
    }
    #content > div {
        width: 100%;
    }
    .close {
        color: #aaaaaa;
        float: right;
        font-size: 2rem;
        font-weight: bold;
        position: absolute;
        right: 5px;
        top: 0px;
        border-radius: 50%;
        padding-left: 7px;
        padding-right: 7px;
        padding-bottom: 2px;
        margin-top: 5px;
        z-index: 1;
        transition: all .2s linear;
    }
    .close:hover,
    .close:focus {
        color: #ec8c13;
        text-decoration: none;
        cursor: pointer;
        background-color: #6f6f6f;
    }
</style>

<style scoped>
    .icon {
        margin: 50px;
        transition: transform .3s;
        max-width: 200px;
    }
    .icon:hover {
        -webkit-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);
        box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);
        cursor: pointer;
        transform: scale(1.1);
    }
    .sidenav {
        height: 100vh;
        width: 200px;
        z-index: 1;
        top: 100vh;
        left: 0;
        background-color: #303030;
        overflow-x: hidden;
        padding-top: 50px;
        position: absolute;
    }
    .sidenav a {
        padding: 6px 8px 6px 16px;
        text-decoration: none;
        font-size: 25px;
        color: #818181;
        display: block;
    }
    .sidenav a:hover {
        background-color: #f7f7f7;
        color: #4c4c4c;
    }
    #selected {
        background-color: #f7f7f7;
        color: #4c4c4c;
    }

    #display {
        height: 100vh;
        width: 100%;
        background-color: #f7f7f7;
    }
    #listing {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        flex-direction: row;
        height: 100vh;
        overflow-y: scroll;
        margin-left: 200px;
        padding: 25px;
    }
    /* #listing::after {
        content: "";
        flex: auto;
    } */
    /* .box {
        flex: 1 0 21%;
    } */
</style>